// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__fe3OA","rolesWrapper":"styles_rolesWrapper__2AmOg","role":"styles_role__R6QDQ"};